import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Select from "react-select";

import axios from "../../../../axios-instance";
import Container from "../../../../components/UI/Container/Container";
import Page404 from "../../../../components/Page404/Page404";
import NewLoader from "../../../../components/NewLoader/NewLoader";

import "../SeasonPassPersonalInfo.sass";
import { ticketTemplateIds } from "../../constants";
import { getCurrentLanguageTexts, languagesList } from "../../../../constants/seasonPassPersonalInfoLangs";

import { editMembeshipCardInfo, getMemberCards } from "../../../../store/actions/memberActions";
import { MemberShipTickets } from "../MembershipTickets";
import ls from 'localstorage-slim';
import 'react-phone-input-2/lib/style.css';
import { handleOrderStatus } from "../../../../components/Sells/Modals/statusModals";
import { getOc } from "../../../../helpers/optionalChain.ts";
import EmptyStateImg from '../../../../images/no-future-events.png';

const MySwal = withReactContent(Swal);

export const MemberTickets = ({
    dispatch,
    membershipList,
    getMemberCards,
    editMembeshipCardInfo,
    handleChangeLang,
    lang,
    isFramed,
    ...params
}) => {
    const [isLoadingState, setIsLoadingState] = useState(true);
    const [isMemberFound, setIsMemberFound] = useState(false);
    const [isEventDataLoading, setIsEventDataLoading] = useState(false);

    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [streetAndHouseNumber, setStreetAndHouseNumber] = useState("");
    const [city, setCity] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [gender, setGender] = useState(null);
    const [birthday, setBirthday] = useState(null);

    const txt = getCurrentLanguageTexts();

    const token = ls.get('member-access-token', '');

    const authResult = queryString.parse(params.location.search)["?authResult"];

    const getEventData = async () => {
        setIsEventDataLoading(true);
        setIsEventDataLoading(false);
    };

    const getOrderData = async () => {
        const urlParams = new URL(window.location.href).searchParams;
        let orderId = urlParams.get('resultOrderId');

        if (!!orderId) {
            if (orderId.indexOf('?') > 0) {
                orderId = orderId.substring(0, orderId.indexOf('?'))
            }
            const { data } = await axios.get(
                `Order/${orderId}?byTransactionId=true`);

            handleOrderStatus({
                status: data.status,
                orderId,
                buyerEmail: data.info.buyerEmail,
                additionalPaymentStatus: data.externalStatus,
                paymentData: data.paymentDate,
                buyMoreUrl: window.location.pathname,
                authCode: getOc(data, '?.info?.kopaInfo?.authCode', ' '),
                reloadData: getOrderData,
            })
        }
    }

    const loadSeasonPassMember = async () => {
        await axios
            .get(`/SeasonPassMember?accessToken=${token}`)
            .then(async (response) => {
                if (response.status === 200 && response.data) {
                    setFirstname(response.data.firstName);
                    setLastname(response.data.lastName);
                    setEmail(response.data.email);
                    setGender(response.data.gender);

                    getOrderData();

                    setPhone(response.data.phoneNumber);
                    setStreetAndHouseNumber(response.data.physicalAddress);
                    setCity(response.data.city);
                    setPostalCode(response.data.postalCode);

                    if (response.data.dateOfBirth && response.data.dateOfBirth !== "0001-01-01T00:00:00") {
                        setBirthday(response.data.dateOfBirth);
                    }

                    //handleLang(response.data.lang);
                    if (response.data.status === 3) {
                        getEventData();
                    }
                    localStorage.setItem('user_' + response.data.email.toLowerCase().trim(), token);
                    setIsMemberFound(true);
                    setIsLoadingState(false);

                    return;
                }

                throw new Error(response.data.errorMessage);
            })
            .catch((err) => {
                setIsLoadingState(false);
                setIsMemberFound(false);
            });

        await axios
            .get(`/Membership/passes?accessToken=${token}`)
            .then((response) => {
                if (response.status === 200 && response.data) {

                    setIsMemberFound(true);
                    setIsLoadingState(false);
                    return;
                }

                throw new Error(response.data.errorMessage);
            })
            .catch((err) => {
                setIsLoadingState(false);
                setIsMemberFound(false);
            });
    };

    useEffect(() => {
        if (token) {
            getMemberCards(token, process.env.REACT_APP_MEMBER_EVENT_ID);
        }
    }, [token]);

    useEffect(() => {
        loadSeasonPassMember();
    }, [authResult]);

    useEffect(() => {
        window.addEventListener('beforeunload', (event) => {
            MySwal.close();
            setIsLoadingState(true);
        });

        window.addEventListener('pageshow', event => {
            if (event.persisted) {
                window.location.reload();
            }
        });
    }, [])

    if (isLoadingState || isEventDataLoading) {
        return <NewLoader />;
    }

    if (!isMemberFound) {
        return <Page404 isBackBtn={false} isRefreshAvailable={true} />;
    }

    return (
        <Container className="seasonpass seasonpass-pers-info">
            {!isFramed &&
                <div className="seasonpass-pers-info__logo seasonpass-pers-info__header-logo-wrapper">
                </div>
            }
            <div className="seasonpass-pers-info__main-block">
                {!isFramed &&
                    <Select
                        options={languagesList}
                        name="language"
                        value={languagesList.find(({ value }) => lang === value)}
                        onChange={handleChangeLang}
                        classNamePrefix="partizan-open-selling__select"
                        className="partizan-open-selling__select partizan-open-selling__select--lang"
                    />
                }

                {membershipList.length > 0
                    ? <>
                        <MemberShipTickets memberData={{
                            fullName: firstname + ' ' + lastname,
                            physicalAddress: streetAndHouseNumber,
                            city: city,
                            postalCode: postalCode,
                            phoneNumber: phone,
                            buyerEmail: email,
                            gender: gender,
                            buyerCountry: 'Srbija',
                            birthday,
                            membershipsCount: membershipList.filter(m => isNewMemebership(m.templateId)).length,
                        }} />
                    </>

                    : <div className="seasonpass-pers-info__empty-state">
                        <h4>{txt.memberEventsList.emptyState}</h4>
                        <img className="seasonpass-pers-info__empty-state-image" src={EmptyStateImg} alt="No future event" />
                    </div>
                }
            </div>
        </Container>
    );
};

const mapStateToProps = ({ member }) => ({
    membershipList: member.membershipList,
});
const mapDispatchToProps = (dispatch) => ({
    getMemberCards: (accessToken, eventId) =>
        dispatch(getMemberCards(accessToken, eventId)),
    editMembeshipCardInfo: (accessToken, ticket) =>
        dispatch(editMembeshipCardInfo(accessToken, ticket)),
    dispatch: (foo) => dispatch(foo),
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberTickets)


const isNewMemebership = (ticketTemplateId) => {
    return ticketTemplateIds.adult.includes(ticketTemplateId) || ticketTemplateIds.child.includes(ticketTemplateId);
}